export const forumType = {
  GET_FORUM: "get_forum",
  GET_FORUM_PATH: "get_forum_path",
};
